export class IInventoryCounter {
  inventoryCountId: string;
  hrRef: number;
  employeeName?: string;
}
